export const transformProfileUserInfoDto = response => ({
  canAddFeedback: response.can_add_feedback,
  urlForLastUnfeedbackedTransaction: response.url_for_last_unfeedbacked_transaction,
  canSendTemplates: response.can_send_templates,
  showSupportFunctionality: response.show_support_functionality,
  shadowBanned: response.shadow_banned
});